export const AI_SUMMARY_KEYS = {
    TABLE_ID: "table_id",
    DATE: "date",
    DIVISION: "division",
    HQ_POOL: "hqPool",
    STATE: "state",
    STAFF_NAME: "staffName",
    STAFF_EMPLOYEE_CODE: "staffEmployeeCode",
    MANAGER_NAME: "managername",
    MANAGER_CODE: "managercode",
    EXPENSE_TYPE: "expenseType",
    STANDARD: "standard",
    CLAIMED: "claimed",
    AI_DECISION: "aiDecision",
    AI_AMOUNT: "aiAmount",
    AI_SUMMARY: "aiSummary",
    ADMIN_AMOUNT: "adminAmount",
    ADMIN_SUMMARY: "adminSummary",
    ACCURACY: "accuracy"
};

export const AI_Summary_Constants = {
    AI_SUMMARY_PAGE_SIZE: 5,
    Previous_BUTTON: "Previous",
    Next_BUTTON: "Next",
    Page: "Page",
    AI_SUMMARY: "AI Summary",
    Close_BUTTON: "Close",
    NO_RECORD_FOUND_MESSAGE: "No record found",
    AI_SUMMARY_EXPENSE: "AI Expense Summary",
    CATEGORY_TOTAL_CASES: "Total Cases",
    CATEGORY_ADMIN_AMOUNT: "Admin Amount",
    CATEGORY_AI_AMOUNT: "AI Amount",
    CATEGORY_APPROVED: "Approved",
    CATEGORY_MODIFIED: "Modified",
    CATEGORY_REVIEW: "Review"
};

export const keyMap: Record<string, string> = {
    table_id: 'ID',
    date: 'DATE',
    division: 'DIVISION',
    hqPool: 'HQ POOL',
    state: 'STATE',
    staffName: 'STAFF NAME',
    staffEmployeeCode: 'STAFF EMPLOYEE CODE',
    managername: 'MANAGER NAME',
    managercode: 'MANAGER CODE',
    expenseType: 'EXPENSE TYPE',
    standard: 'STANDARD',
    claimed: 'CLAIMED',
    aiDecision: 'AI DECISION',
    aiAmount: 'AI AMOUNT',
    aiSummary: 'AI SUMMARY',
    adminAmount: 'ADMIN AMOUNT',
    adminSummary: 'ADMIN SUMMARY',
    accuracy: 'ACCURACY'
};

/**
 * Color scheme for statistics cards
 */
export const CARD_COLORS = {
    TOTAL_CASES: '#4A90E2',
    APPROVED_CASES: '#50C878',
    MODIFIED_CASES: '#FFB84D',
    REVIEW_CASES: '#FF6B6B',
    DEFAULT: '#1976d2'
};

/**
 * Expense categories
 */
export const EXPENSE_CATEGORIES = {
    TA: 'TA',
    DA: 'DA',
    FLIGHT_TRAIN: 'Flight & Train',
    COURIER: 'Courier',
    TAXI_FARE: 'Taxi Fare',
    RAILWAY_PASS: 'Railway Pass',
    STATIONERY: 'Stationery'
};

/**
 * AI Decision types
 */
export const AI_DECISIONS = {
    APPROVED: 'Approved',
    MODIFIED: 'Modified',
    REJECTED: 'Rejected'
};

/**
 * Grid configuration
 */
export const GRID_CONFIG = {
    ROW_HEIGHT: 30,
    MIN_COLUMN_WIDTH: 80,
    DEFAULT_COLUMN_WIDTH: 150,
    MAX_GRID_HEIGHT: 500
};


